module.exports = __webpack_public_path__ + "img/keyBuckle_10.ba2cd0e8.jpg";